import { h } from 'preact'

export const ReassuranceTv = ({ title, image, alt, CTA, cacheKey, links }) => {
   return (
      <div class="container-fluid">
         <div class="reassurance-tv row mb-4" id="zone_reassurance_tv" data-testid="bande-reassurance-tv" data-cache-key={cacheKey}>
            <div class="col-12">
               <h2 class="mb-2">{title}</h2>
            </div>

            <div class="col-12 col-md-7 p-0 pl-md-1 pr-md-1 mb-1 mb-md-0">
               <picture>
                  <source srcset={`${image}?format=400x&saveas=webp`} media="(max-width: 959px)" />
                  <source srcset={`${image}?format=500xsaveas=webp`} media="(max-width: 959px)" />
                  <source srcset={`${image}?format=630x&saveas=webp`} media="(max-width: 1199px)" />
                  <img src={`${image}?format=800x&saveas=webp`} class="mw-100" alt={alt} loading="lazy" />
               </picture>
            </div>

            <div class="col-12 col-md-5 pl-md-2 d-flex flex-column justify-content-center">
               <ul class="align-self-start">
                  {links.map(({ label, target, URL, analytics }) => (
                     <li>
                        <a
                           href={URL}
                           class="o-link-arrow mb-1 mw-100"
                           data-pdb-zid={analytics.pdbZid}
                           data-pdb-sc={analytics.pdbSc}
                           data-pdb-idc={analytics.pdbIdc}
                           data-pdb-vi="*"
                           data-oevent-category={analytics.oeventCategory}
                           data-oevent-action={analytics.oeventAction}
                           data-oevent-label={analytics.oeventLabel}
                           data-oevent-other={analytics.oeventOther}
                           target={target}
                        >
                           {label}
                        </a>
                     </li>
                  ))}
               </ul>
               <a
                  href={CTA.URL}
                  aria-label={CTA.ariaLabel}
                  class="btn btn-secondary align-self-center align-self-md-start"
                  data-pdb-zid={CTA.analytics.pdbZid}
                  data-pdb-sc={CTA.analytics.pdbSc}
                  data-pdb-idc={CTA.analytics.pdbIdc}
                  data-pdb-vi={CTA.analytics.pdbVi}
                  data-oevent-category={CTA.analytics.oeventCategory}
                  data-oevent-action={CTA.analytics.oeventAction}
                  data-oevent-label={CTA.analytics.oeventLabel}
                  data-oevent-other={CTA.analytics.oeventOther}
               >
                  {CTA.label}
               </a>
            </div>
         </div>
      </div>
   )
}
